import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import AspectRatio from 'components/utils/AspectRatio'
import React from 'react'
import { useIntl } from 'react-intl'
import Image from 'components/Common/Image/Image'

export enum OfficeLocations {
  MELBOURNE = 'Melbourne',
  CHADSTONE = 'Chadstone',
  SYDNEY = 'Sydney',
  BONDI = 'Bondi',
  SINGAPORE = 'Singapore',
}

export const OFFICE_LOCATION_CONTENT = {
  offices: [
    { location: OfficeLocations.MELBOURNE, officeTitle: 'Melbourne Office', address: 'Level 4, 68 Clarke Street, Southbank, VIC 3006, Australia', imageId: 'q1tf7pylqjcf8a67j8ik' },
    { location: OfficeLocations.CHADSTONE, officeTitle: 'Chadstone Retail Store', address: 'Chadstone Shopping Centre - Lower Ground, 1341 Dandenong Rd, Malvern East VIC 3148', imageId: 'stfnt9kfcmt08sq4hbcj' },
    { location: OfficeLocations.SYDNEY, officeTitle: 'Sydney Office', address: 'Level 28, 201 Kent Street, Sydney 2000, NSW, Australia', imageId: '8an3e7vdvcrmwgu2z5qi' },
    { location: OfficeLocations.BONDI, officeTitle: 'Westfield Bondi Junction Retail Store', address: 'Ground Floor, Oxford Street entrance at Bondi Junction (Shop 3042 & 3043)', imageId: '63y27jyk5sop54l6mxb7l' },
    { location: OfficeLocations.SINGAPORE, officeTitle: 'Singapore Office', address: '27B Teo Hong Road, Singapore 088334', imageId: 'c2hnjcrf99m4xjrs16om' },
  ],
}

interface Props {
  selectedOffice: OfficeLocations
}

function OfficeLocationModal(props: Props) {
  const intl = useIntl()
  const { selectedOffice } = props
  const selectedOfficeContent = OFFICE_LOCATION_CONTENT.offices.find(office => office.location === selectedOffice) || OFFICE_LOCATION_CONTENT.offices[0]

  const officeTitles: Record<OfficeLocations, string> = {
    [OfficeLocations.MELBOURNE]: intl.formatMessage({
      id: 'RLelgB0RtQpOCme1l3OP',
      defaultMessage: 'Melbourne Office',
      description: 'Office location modal - Melbourne office title on the about us page',
    }),
    [OfficeLocations.CHADSTONE]: intl.formatMessage({
      id: '6I52NYQYixZnCXTbj-Xp',
      defaultMessage: 'Chadstone Retail Store',
      description: 'Office location modal - Chadstone retail store title',
    }),
    [OfficeLocations.SYDNEY]: intl.formatMessage({
      id: 'OYhBzqdMRSfTzfVIaw30',
      defaultMessage: 'Sydney Office',
      description: 'Office location modal - Sydney office title dialog window',
    }),
    [OfficeLocations.BONDI]: intl.formatMessage({
      id: 'P-nr0S9csPcT7V_5Xkkm',
      defaultMessage: 'Westfield Bondi Junction Retail Store',
      description: 'Office location modal - Bondi Junction retail store title',
    }),
    [OfficeLocations.SINGAPORE]: intl.formatMessage({
      id: 'cHolm2hlqBu7tvjfzWUD',
      defaultMessage: 'Singapore Office',
      description: 'Office location modal - Singapore office title on the about us page',
    }),
  }

  const translatedTitle = officeTitles[selectedOffice] ?? selectedOfficeContent.officeTitle

  return (
    <ModalBase>
      <ModalHeader title={translatedTitle} subtitle={selectedOfficeContent.address} />
      <AspectRatio ratio="2:1" tabletRatio="16:8">
        <Image id={selectedOfficeContent.imageId} fit="center" />
      </AspectRatio>
    </ModalBase>
  )
}

export default OfficeLocationModal
